module.exports = __webpack_public_path__ + "img/charge_status_4.0de6f93e.png";